module.exports = __webpack_public_path__ + "infocentrum20.jpg?30355692eabd23c544841a0afe09ec65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum20.jpg
// module id = 272
// module chunks = 0